module.exports = __webpack_public_path__ + "img/logo-small.2585e8cf.png";